import { createSelector } from 'reselect';

const selectServiceability = (state: any) => state.serviceabilities;


export const selectServiceabilityCurrentItem = createSelector([selectServiceability], (serviceabilities) => serviceabilities.current);

export const selectServiceabilityListItems = createSelector([selectServiceability], (serviceabilities) => serviceabilities.list);

export const selectServiceabilityItemById = (itemId: any) =>
    createSelector(selectServiceabilityListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectServiceabilityQueryItems = createSelector([selectServiceability], (serviceabilities) => serviceabilities.query);

export const selectServiceabilityCreatedItem = createSelector([selectServiceability], (serviceabilities) => serviceabilities.create);

export const selectServiceabilityUpdatedItem = createSelector([selectServiceability], (serviceabilities) => serviceabilities.update);

export const selectServiceabilityReadItem = createSelector([selectServiceability], (serviceabilities) => serviceabilities.read);

export const selectServiceabilityDeletedItem = createSelector([selectServiceability], (serviceabilities) => serviceabilities.delete);

export const selectServiceabilitySearchedItems = createSelector([selectServiceability], (serviceabilities) => serviceabilities.search);

export const selectServiceabilityItemsCount = createSelector([selectServiceability], (serviceabilities) => serviceabilities.count);

export const selectServiceabilityItemsFilter = createSelector([selectServiceability], (serviceabilities) => serviceabilities.filter);